/** Complete startup after translations and route-scoped components settle. */
export function completeAlpineBootstrap(translationsReady, componentsReady, lifecycle) {
    return Promise.allSettled([translationsReady, componentsReady]).then((results) => {
        if (lifecycle.isNavigationScheduled()) return false;

        const componentsLoaded = results[1].status === 'fulfilled' && results[1].value;
        if (componentsLoaded && !lifecycle.isRecoveryExhausted()) {
            lifecycle.finishRecovery();
        }
        lifecycle.start();
        return true;
    });
}
